module.exports = __webpack_public_path__ + "img/Realisme_Naturalismen_Skram.5581c685.jpg";